// @flow
import styled from '@emotion/styled'
import { withPrefix } from 'gatsby'
import * as React from 'react'

import { colors, media } from '@toggl/style'

import { heading4, paragraph3 } from '../text'

type Props = {|
  +img: {|
    alt: string,
    src: string,
    width?: string,
    height?: string,
    marginLeft?: string,
    marginTop?: string,
  |},
  +link?: string,
  +title: string,
  +details: string,
|}

export default function Workflow({ img, link, title, details }: Props) {
  const element = (
    <React.Fragment>
      <ImageWrapper>
        <Image {...img} loading="lazy" />
      </ImageWrapper>
      <Title>{title}</Title>
      <Details>{details}</Details>
    </React.Fragment>
  )

  return link ? (
    <StyledLink href={withPrefix(link)}>{element}</StyledLink>
  ) : (
    element
  )
}

const Title: React.ComponentType<any> = styled.div`
  ${heading4};

  color: ${colors.darkPurple};
  margin-bottom: 15px;
`

const StyledLink: React.ComponentType<any> = styled.a`
  margin: 20px 20px 40px;
  display: block;
  &:hover {
    ${Title} {
      color: ${colors.pink};
    }
  }
  ${media.mq[1]} {
    min-width: auto;
    padding: 20px;
    flex: 1;
    margin-bottom: 0;
  }
  ${media.mq[2]} {
    padding: 0 20px;
  }
`

const Details: React.ComponentType<any> = styled.div`
  ${paragraph3};

  color: ${colors.fadedPurple};
`

const ImageWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 180px;
  width: 180px;
  border-radius: 50%;
  background: ${colors.lightBeige};
  margin: 20px auto;

  ${media.mq[1]} {
    margin-bottom: 30px;
  }
`

const Image = styled.img`
  object-fit: contain;

  width: ${({ width }) => width || '90%'};
  height: ${({ height }) => height || '90%'};

  margin-top: ${({ marginTop }) => marginTop || 0};
  margin-left: ${({ marginLeft }) => marginLeft || 0};
`
